import React from 'react';

import { UtilityFooterLayout } from 'design/utilityFooterLayout';
import { InlineLayout } from 'design/inlineLayout';
import { originSiteMap, ORIGIN_SITE_URL } from 'utils/constants';
import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';

export const UtilityFooter = () => {
  const copyrightNode = React.useMemo(() => {
    const year = new Date().getFullYear();

    const copyrightText = `© ${year} Agmsoft`;

    return (
      <TextComponent color="secondary" size="m">
        {copyrightText}
      </TextComponent>
    );
  }, []);

  const linksNode = React.useMemo(() => {
    return (
      <InlineLayout gap="14px">
        <LinkControlComponent newTab to={ORIGIN_SITE_URL}>
          <TextComponent size="m" color="secondary">
            О программе
          </TextComponent>
        </LinkControlComponent>
        <LinkControlComponent newTab to={originSiteMap.TERMS_URL}>
          <TextComponent size="m" color="primary">
            Пользовательское соглашение
          </TextComponent>
        </LinkControlComponent>
        <LinkControlComponent newTab to={originSiteMap.PRIVACY_URL}>
          <TextComponent size="m" color="primary">
            Политика конфиденциальности
          </TextComponent>
        </LinkControlComponent>
        <LinkControlComponent newTab to={originSiteMap.AGREEMENT_URL}>
          <TextComponent size="m" color="primary">
            Лицензионное соглашение
          </TextComponent>
        </LinkControlComponent>
      </InlineLayout>
    );
  }, []);

  return (
    <UtilityFooterLayout copyrightNode={copyrightNode} linksNode={linksNode} />
  );
};
